import axios from 'axios'
import { toast } from 'react-toastify'


interface PropData {
  action: string
  body?: any
  isFormData?: boolean
  isShowError?: boolean
  id?: string
  type?: string
  key?: any
  file?: any
  ProgressBar?: any
}

const WebService = {
  getAccesstoken: function (props: PropData) {
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams()
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key])
      }
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        tenantId: '' + localStorage.getItem('tenantId')
      }
      axios
        .post(`${url}${props.action}`, bodyFormData, {
          headers: headers
        })
        .then((response) => {
          localStorage.setItem('token', response?.data.access_token)
          resolve(response?.data)
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          this.removeLoader(props?.id)
          reject(this.errorHandler(error))
        })
    })
  },

  postAPI: function <T>(props: PropData) {
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise<T>((resolve, reject) => {
      var bodyFormData = new URLSearchParams()
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key])
      }
      axios
        .post(`${url}${props.action}`, props.isFormData ? bodyFormData : props.body, {
          headers: this.getHeaders()
        })
        .then((response) => {
          resolve(response?.data)
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          if (error && error?.response && error?.response.status == 401) {
            this.clearLocalStorage()
          }
          this.removeLoader(props?.id)
          reject(this.errorHandler(error))
        })
    })
  },

  putAPI: function (props: PropData) {
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams()
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key])
      }
      axios
        .put(`${url}${props.action}`, props.body, {
          headers: this.getHeaders()
        })
        .then((response) => {
          resolve(response?.data)
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          if (error && error?.response && error?.response.status == 401) {
            this.clearLocalStorage()
          }
          this.removeLoader(props?.id)
          reject(this.errorHandler(error))
        })
    })
  },

  getAPI: function <T>(props: PropData) {
    let params = new URLSearchParams()
    for (let key in props.body) {
      ; (props.body[key] || props.body[key] === 0) && params.set(key, props.body[key])
    }
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise<T>((resolve, reject) => {
      axios
        .get(`${url}${props.action}`, {
          params: params,
          headers: this.getHeaders()
        })
        .then((response) => {
          resolve(response?.data)
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          if (error && error?.response && error?.response.status == 401) {
            this.clearLocalStorage()
          }
          this.removeLoader(props?.id)
          reject(this.errorHandler(error))
        })
    })
  },

  deleteAPI: function <T>(props: PropData) {
    let params = new URLSearchParams()
    for (let key in props.body) {
      params.set(key, props.body[key])
    }
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise<T>((resolve, reject) => {
      axios
        .delete(`${url}${props.action}`, {
          params: params,
          headers: this.getHeaders()
        })
        .then((response) => {
          resolve(response?.data)
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          if (error && error?.response && error?.response.status == 401) {
            this.clearLocalStorage()
          }
          this.removeLoader(props?.id)
          reject(this.errorHandler(error))
        })
    })
  },

  fileUploadAPI: function (props: PropData) {
    var formData = new FormData();
    if (!props.key) {
      props.key = "file";
    }
    formData.append(props.key, props.file);
    for (let key in props.body) {
      formData.append(key, props.body[key]);
    }
    this.addLoader(props?.id);
    let url = this.getBaseUrl();
    return new Promise((resolve, reject) => {
      axios
        .post(`${url}${props.action}`, formData, {
          headers: this.getMultipartHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          // props.isShowError ? reject(this.errorHandler(error)) : reject(error);
          this.errorHandler(error);
          this.removeLoader(props?.id);
        });
    });
  },

  getHeaders: function () {
    return {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      tenantId: localStorage.getItem('tenantId') || ''
    }
  },

  getMultipartHeaders: function () {
    if (typeof window !== 'undefined') {
      return {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      };
    }
  },

  errorHandler: function (error: any) {
    if (error?.response) {
      error = error?.response
    }
    var errorMessage
    // if (!error || !error?.status) {
    //   errorMessage = "Server Not Responding";
    // } else
    if (error?.status == 401) {
      // this.clearLocalStorage()
      // window.location.href = '/'
    } else if (error?.status == 500) {
      errorMessage =
        (error && error?.data && error?.data?.ErrorDetails && error?.data?.ErrorDetails?.message) ||
        'An unkown exception has occured. Please contact to administrator'
    } else {
      errorMessage = error?.data?.message
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 4000 })
    }
    return errorMessage
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null
      if (button != null) {
        button.disabled = true
        var loader = document.createElement('img')
        loader.src = '/images/loading.gif'
        loader.className = 'button-loader'
        button.prepend(loader)
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null
      if (button != null) {
        button.disabled = false
        button.removeChild(button.childNodes[0])
      }
    }
  },

  clearLocalStorage() {
    const posWebUrl = localStorage.getItem("pos_web_url");
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_info');
    localStorage.removeItem('pos_web_url');
    sessionStorage.clear();
    window.location.href = posWebUrl || '/';
  },

  getTruncatedWithTooltip: function (text: string, limit: number = 30): any {
    const truncated = text && text.length > limit ? text.substring(0, limit) + '...' : text
    return <span title={text}>{truncated}</span>
  },

  getBaseUrl(type?: string) {
    // const ipAddress = localStorage.getItem('ip_address') || 'localhost'
    // return 'http://' + ipAddress + ':3007/'


    // return "http://127.0.0.1:8000/api"; //LOCAL
    return "https://gprestaurantapi.winayak.com/api";  //DEV
    // return "https://gpapi.winayak.com/api" // PROD
  },

  getSubDomain() {
    if (window.location.hostname == 'localhost') {
      if (
        window.location.href == 'http://localhost:3000/login' ||
        window.location.href == 'http://localhost:3000/'
      ) {
        return ''
      } else {
        return 'http://' + window.location.host
      }
    } else {
      return 'https://' + window.location.hostname
    }
  }
}

export default WebService;